import { createI18n } from 'vue-i18n'
import isoCountries from 'i18n-iso-countries'

// Locales
import enLocale from '../locales/en.json'
import deLocale from '../locales/de.json'

export const i18n = createI18n({
    legacy: false,
    locale: 'de',
    fallbackLocale: 'de',
    messages:{
        gb: enLocale,
        de: deLocale
    }
})

isoCountries.registerLocale(require("i18n-iso-countries/langs/en.json")); // registration of english translation
isoCountries.registerLocale(require("i18n-iso-countries/langs/de.json")); // registration of german translation

export default isoCountries;
